<div>
    <div *ngIf="isLoading" class="text-center p-4">
        <div class="spinner-border" role="status">
            <span class="sr-only">Chargement...</span>
        </div>
    </div>

    <table class="table table-hover" *ngIf="!isLoading">
        <thead class="align-middle custom-header">
        <tr class="text-start">
            <th>DATE</th>
            <th>TYPE</th>
            <th class="uppercase">Numéro</th>
            <th>MONTANT</th>
            <th class="uppercase">ACTIONS</th>
        </tr>
        </thead>
        <tbody>
        <tr class="ligne text-start" *ngFor="let paiement of paiementsNonAffectes; trackBy: trackByPaiementId">
            <td class="padd" style="width: 15%">{{ formatDate(paiement.date) }}</td>
            <td class="titre1 padd">{{ getTypePaiementLabel(paiement.type) }}</td>
            <td class="titre3 padd">{{ paiement.numero || paiement.reference || '--' }}</td>
            <td class="titre3 padd">{{ formatMontant(paiement.montant) | number:'1.2-2' }} TND</td>
            <td class="titre3 padd">
                <button class="btn btn-sm btn-primary" (click)="affecterPaiement(paiement)">
                    Affecter
                </button>
            </td>
        </tr>
        <tr *ngIf="paiementsNonAffectes.length === 0 && !isLoading">
            <td colspan="5" class="text-center p-4">
                <p class="mb-0">Aucun paiement non affecté</p>
            </td>
        </tr>
        </tbody>
    </table>
</div>
